export default {
  translation: {
    common: {
      emailOrUsername: 'E-mail lub nazwa użytkownika',
      invalidEmailOrUsername: 'Błędny e-mail lub nazwa użytkownika',
      invalidPassword: 'Błędne Hasło',
      noInternetConnection: 'Brak połączenia z internetem',
      pageNotFound_title: 'Nie znaleziono strony',
      password: 'Hasło',
      projectManagement: 'Zarządzanie projektem',
      serverConnectionFailed: 'Błąd połączenia z serwerem',
      unknownError: 'Nieznany błąd, spróbuj ponownie później',
    },

    action: {
      logIn: 'Zaloguj',
    },
  },
};
